/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { JobContext } from '../JobContext/JobContext.entity';
import { PaginationLinks } from '../PaginationLinks/PaginationLinks.entity';

export type EntityJobContexts = io.TypeOf<typeof JobContexts>;

export const JobContexts = io.intersection([
  io.type({
    data: io.array(JobContext),
  }),
  io.partial({
    links: PaginationLinks,
  }),
]);
